<template>

  <div class="d-flex justify-content-between align-items-center my-2">
    <b-form-select
      v-model="selectedOption"
      :options="dropdownOptions"
      class="mr-2"
      style="max-width: 200px;"
    />

    <b-button
      variant="primary"
      :disabled="updating"
      @click="handleUpdate"
    >
      <b-spinner
        v-if="updating"
        small
      />
      Update
    </b-button>
  </div>
</template>

<script>
import { BButton, BFormSelect, BSpinner } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'

const KEY_OPTIONS = {
  RIDER_HEALTH: 'Rider-Health',
  DRIVER_HEALTH: 'Driver-Health',
}

const dropdownOptions = [
  { value: KEY_OPTIONS.RIDER_HEALTH, text: 'Rider Health' },
  { value: KEY_OPTIONS.DRIVER_HEALTH, text: 'Driver Health' },
  // Add more options here if needed
]
export default {
  components: {
    BFormSelect,
    BButton,
    BSpinner,
  },
  setup() {
    const selectedOption = ref(KEY_OPTIONS.RIDER_HEALTH)

    const updating = ref(false)
    const handleUpdate = async () => {
      updating.value = true
      try {
        await axiosIns.post('/users/dashboard-health', {
          jobName: 'export-redshift-query-to-scylla',
          key: selectedOption.value,
        })
        successNotification('Successfully updated')
      } catch (err) {
        errorNotification('Failed updating')
      } finally {
        updating.value = false
      }
    }
    return {
      updating,
      handleUpdate,
      dropdownOptions,
    }
  },
}
</script>
